import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListLeasetype({
    loading,
    filteredLeases,
    selected,
    handleSelect,
    handleToggleStatus,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Lease Type</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="3" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredLeases.length > 0 ? (
                        filteredLeases.map((l) => {
                            const isActive = l.status === "Active";
                            return (
                                <tr key={l.id}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="leaseSelect"
                                            disabled={l.status === "Inactive"}
                                            checked={selected === l.id}
                                            onChange={() => handleSelect(l.id)}
                                        />
                                    </td>
                                    <td>{l.leaseType}</td>
                                    <td>
                                        <button
                                            type="button"
                                            className={`badge border-0 ${isActive ? "bg-success" : "bg-secondary"
                                                }`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleStatus(l)}
                                            disabled={loading}
                                        >
                                            {l.status}
                                        </button>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="3" className="text-center text-muted">
                                No lease types found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
